var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-nav-item',{attrs:{"to":{ name: 'ManageBDX' }}},[_c('b-icon-exclamation-triangle',{staticClass:"text-danger"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }